// This is only relevant for svgs generated on the frontend.
// Backend rendered ones already have the sprite URL prepended so
// server renders them with class="inited" to avoid double prepending.
;(() => {
  function prependSpriteUrl(node) {
    if (node.closest(".pswp")) return
    node.classList.add("inited")
    const $node = $(node)
    const val = $node.attr("href")
    $node.attr("href", `${svg_sprite_url}${val}`)
  }

  function callback() {
    requestAnimationFrame(() => {
      document
        .querySelectorAll('use:not([class="inited"])')
        .forEach(prependSpriteUrl)
    })
  }

  function loadSprite(throttleCallback) {
    const observer = new MutationObserver(throttleCallback)
    observer.observe(document.documentElement, {
      subtree: true,
      childList: true,
    })
    throttleCallback()
  }

  $(() => {
    const throttleCallback = HB.throttle(callback, 200)
    loadSprite(throttleCallback)
  })
})()
